import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  font-size: larger;
  font-weight: bold;
  margin-bottom: 26px;
`

const LeadParagraphControl = (props: PropsWithChildren<{}>) => (
  <Container>{props.children}</Container>
)

export default LeadParagraphControl
